<template>
    <div class="HelpWarp">
        <NavMenu/>
        <div class="typeArae">
            <div class="pagecenter">
                <div class="Title">中国人才交流协会网站帮助中心
                </div>
            </div>

            <div class="centerbox" v-if="dataList.length!=0">
                <div class="text">常见问题</div>
                <div v-for="(item,index) in dataList" :key="index" class="databox">
                    <div class="helpItemBox">
                        <div class="titlebox" @click="getDetailFn(item,index)">
                            <span class="dot"></span>{{item.pressTopic}}</div>
                        <div class="synopsisbox">
                            {{item.synopsis}}
                        </div>
                        <!-- <div class="synopsisbox" v-if="currentindex==index&&newsDetailObj">
                            <div v-html="newsDetailObj.content"></div>
                        </div> -->
                    </div>

                </div>
                <div class="pagination-box">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                        :page-sizes="[8, 10, 12,16]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>

            </div>
            <div class="emptyBox" v-else>
                <img src="@/assets/imgs/home/emptyimg.png" />

            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            total: 10,
            pageSize: 8,
            dataList: [],
            currentindex: -1,
            newsDetailObj: null,
        }
    },
    created() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass: 46,
                audit:1,
                status:1
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
            }
        },
        async getDetailFn(val, i) {
            // this.currentindex = i;
            // let data = await httpService.getNewsDetails(val.pressId);
            // if (data.code == 200) {
            //     this.newsDetailObj = data.result;
            // } else {
            //     this.$message.error(data.message);
            // }
            let currentNew = {
                menuurl: '/help',
                currentPage: this.currentPage,
                site: window.scrollY,
                title: '帮助中心'
            }
            sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
            sessionStorage.removeItem('childMenuObj')
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },


    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.HelpWarp {
	width: 100%;
	margin: 0 auto;
	.pagecenter {
		padding: 50px 0 36px 0;
		box-sizing: border-box;
		.Title {
			font-size: 26px;
			font-weight: bold;
			line-height: 35px;
			color: #333333;
			text-align: center;
			position: relative;
			border-bottom: 1px solid #dddddd;
			padding-bottom: 10px;
		}
		.Title::before {
			content: '';
			position: absolute;
			width: 68px;
			height: 0px;
			border: 2px solid #448df7;
			opacity: 1;
			background: #448df7;
			left: 50%;
			transform: translateX(-50%);
			top: 42px;
		}
	}
    .typeArae{
        min-height: 520px;
    }
	.text {
		font-size: 20px;
		font-weight: bold;
		line-height: 35px;
		color: #333333;
		margin-bottom: 30px;
	}
	.centerbox {
		width: 1200px;
		margin: 0 auto 60px auto;
		padding: 15px 30px;
		box-sizing: border-box;
		min-height: 380px;
		background: rgba(255, 255, 255, 0.39);
		box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
		.pagination-box {
			margin: 40px 0 20px 0;
		}
		.databox {
			.helpItemBox {
				border-bottom: 1px solid #efefef;
				padding-bottom: 20px;
				margin-bottom: 20px;
				.titlebox {
					display: flex;
					flex-direction: row;
					align-items: center;
					font-size: 18px;
					line-height: 35px;
					color: #333333;
					cursor: pointer;
					&:hover {
						color: #448df7;
					}
					.dot {
						width: 6px;
						height: 6px;
						background: #448df7;
						border-radius: 50%;
						margin-right: 4px;
					}
				}
                .synopsisbox{
                    font-size: 16px;
                    color: #666;
                    text-indent: 6px;
                    padding-top: 10px;
					// transition: all 2s;
                }
			}
		}
	}
}
</style>


